import axios from 'axios';

export const notificationContactsApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/notification-contacts`,
    headers: {
        'Content-Type': 'application/json'
    }
})